/* React */
import React from "react";

/* Utils */
import { ResizeProvider } from "src/utils/provider/resize-provider/ResizeProvider";
import HorizontalBoxplotFilterWrapper from "src/utils/wrapper/horizontal-boxplot-filter-wrapper/HorizontalBoxplotFilterWrapper";

/* Constants */
import { ChartType } from "src/shared/constants/charts/Chart";

/* Interfaces */
import { BaseChartProps } from "src/shared/interfaces/charts/BaseChart";
import { TreatmentPatternsProps } from "src/shared/interfaces/TreatmentPatterns";
import { ComponentProps } from "src/shared/interfaces/common/Layout";

export const createHorizontalBoxplots = (
  outerIndex: number,
  data: BaseChartProps<
    TreatmentPatternsProps[],
    ChartType[][]
  >
): ComponentProps[] => {
  return [
    {
      component: (
        <ResizeProvider withResizer>
          <HorizontalBoxplotFilterWrapper
            data={data.data[outerIndex].boxplot}
          />
        </ResizeProvider>
      ),
      fullWidth: true,
    },
  ];
};
